import React from "react";
import { Link } from "react-router-dom";
import { makeStyles, Grid, Typography } from "@material-ui/core";
import Progress from "./progress";

const useStyles = makeStyles((theme) => ({
  safeColor: {
    color: "#1a90ff",
  },
  warnColor: {
    color: "#ffa31a",
  },
  limitColor: {
    color: "#ff1a1a",
  },
}));

export default function usage({ totalCount, currentLimit, contractLimit, releaseLimit, contractType, exceed }) {
  // TODO: スタータープラン廃止後はスタータープラン関連表示部分を削除する
  const starterPlan = ["devel", "silver", "gold", "platinum", "diamond"];
  const classes = useStyles();
// console.log(exceed);
  const ratio = Math.floor((totalCount / currentLimit) * 100) || 0;
  return (
    <>
      <Grid container alignItems="center" spacing={3}>
        <Grid item>
          <Grid container alignItems="center">
            <Typography variant="h6" component="h6">
              ご契約件数状況：
            </Typography>
            <Typography>
            {ratio < 80 && (
              <span className={classes.safeColor}>{totalCount.toLocaleString()}</span>
            )}
            {(ratio >= 80 && ratio < 90) && (
              <span className={classes.warnColor}>{totalCount.toLocaleString()}</span>
            )}
            {ratio >= 90 && (
              <span className={classes.limitColor}>{totalCount.toLocaleString()}</span>
            )}
              /
            </Typography>
            <Typography>{starterPlan.includes(contractType)
              ? currentLimit.toLocaleString() + "件"
              : currentLimit.toLocaleString() + "件 (" + contractLimit.toLocaleString() + "件)"}</Typography>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container alignItems="center">
            <Typography variant="h6" component="h6">
              使用率：
            </Typography>
            <Typography>
              {ratio < 80 && (
                <span className={classes.safeColor}>{ratio}%</span>
              )}
              {(ratio >= 80 && ratio < 90) && (
                <span className={classes.warnColor}>{ratio}%</span>
              )}
              {ratio >= 90 && (
                <span className={classes.limitColor}>{ratio}%</span>
              )}
            </Typography>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container alignItems="center">
            <Typography variant="h6" component="h6">
              増量オプション：
            </Typography>
            {starterPlan.includes(contractType)
              ? (<Typography>{releaseLimit}回</Typography>)
              : (<Typography>{exceed.remain.toLocaleString()}件</Typography>)}
          </Grid>
        </Grid>
        {starterPlan.includes(contractType) && releaseLimit > 0 && (
          <Grid item>
            <Link
              to="/limit_release"
              style={{ textDecoration: 'none' }}
            >
              <Typography>
                [ご利用はこちら]
              </Typography>
            </Link>
          </Grid>
        )}
      </Grid>

      <Progress ratio={ratio} />
    </>
  );
}
